export const getTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');  // Saat
    const minutes = now.getMinutes().toString().padStart(2, '0');  // Dakika
    return `${hours}:${minutes}`;
};


export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

export const formatDateTime = (dateString: string): string => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));

    if (diffInHours < 1) {
        const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
        return `${diffInMinutes} dakika önce`;
    } else if (diffInHours < 24) {
        return `${diffInHours} saat önce`;
    } else if (diffInHours < 48) {
        return '1 gün önce';
    } else if (diffInHours < 168) {
        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} gün önce`;
    } else {
        const diffInWeeks = Math.floor(diffInHours / 168);
        return `${diffInWeeks} hafta önce`;
    }
};


